
import { defineComponent } from 'vue'

import XTogglePanel from '../../components/x/x-toggle-panel.component.vue'
import { ColorEnum } from '../../enums/color.enum'
import { EpbBadge } from '../shared/epb-badge'
import { EpbText } from '../shared/epb-text'

export default defineComponent({
  name: 'QueryRankingContainer',
  components: {
    XTogglePanel,
    EpbText,
    EpbBadge,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    toolCount: {
      type: Number,
      default: () => undefined,
    },
  },
  setup() {
    return {
      baseClass: 'epb-query-ranking-container',
      ColorEnum,
    }
  },
})
